var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"bubble-container position-relative",style:(_vm.style)},[_c('span',{staticClass:"bubble",domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }